module.exports = __webpack_public_path__ + "presentation-c37e8fbe23723d2cfb1534e450e0dd24.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/file-formats/presentation.svg
// module id = 46
// module chunks = 0